// A share sheet the user dismissed surfaces as an error on some platforms
// (Android OEMs, the browser's own share cancellation): the common cancel
// paths are swallowed instead of alerting on every dismiss. Moved out of
// Logger/useShareCardHandle when the report's pages became a second caller.
const CANCEL_PATTERN = /cancel|user_cancel|did not share/i;

/** Hands a failed share to `onError`, unless the user only dismissed it. */
export function reportShareError(err: unknown, onError?: (message: string) => void) {
  const msg = err instanceof Error ? err.message : String(err);
  if (!CANCEL_PATTERN.test(msg)) onError?.(msg);
}
